/**
 * What each plan step allows (the plans decision, docs/contexts/lfp/adr/
 * 2026-10-22-workspace-plans.md): null is unlimited. Every Free limit leads
 * to adding a card, every Free-with-a-card limit to Pro.
 */
export type WorkspacePlanStep = "free" | "free_card" | "pro";

export type WorkspacePlanLimits = {
  /** Fan club members covered; those past it are locked fans. */
  fanClubMembers: number | null;
  /** Fans sent to each connected CRM. */
  crmSyncFans: number | null;
  /** How far back stats read. */
  statsHistoryDays: number | null;
};

export const WORKSPACE_PLAN_LIMITS: Record<
  WorkspacePlanStep,
  WorkspacePlanLimits
> = {
  free: { fanClubMembers: 50, crmSyncFans: 500, statsHistoryDays: 30 },
  free_card: { fanClubMembers: 100, crmSyncFans: 1_000, statsHistoryDays: 90 },
  pro: { fanClubMembers: null, crmSyncFans: null, statsHistoryDays: null },
};
